import axios from 'axios';
import { getCredentials } from '../sagas/util';

const getReservationByNumber = async (token, reservationNumber) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
      'authentication-token': token
    };

    const response = await axios.get(`${getCredentials().urlB2}reservation/?limit=10&order_by=-id&skip=0&number__ilike_in=${reservationNumber}`, { headers });
    return response?.data?.find(elem => elem.number === reservationNumber);
  } catch (error) {
    return null;
  }
}

const setReservationStatus = async (token, externalId, status) => {
  try {
    const userProducts = JSON.parse(localStorage.getItem('userProducts') || '{}');
    const hashClient = userProducts?.hash_client;
    
    if (!hashClient) {
      console.error('No se encontró hash_client en localStorage');
      return null;
    }

    const headers = {
      'Content-Type': 'application/json',
      'authentication-token': token,
      'hash-client': hashClient
    };

    const credentials = getCredentials();
    const urlCheckout = credentials.urlCheckout;
    const response = await axios.put(`${urlCheckout}operations/set_status/${externalId}/${status}`, {}, { headers });
    
    return response?.data;
  } catch (error) {
    console.error('Error al actualizar el estado de la reserva:', error);
    return null;
  }
}

export {
  getReservationByNumber,
  setReservationStatus
}
